<template>
  <div class="animated fadeIn">
    <h4 class="page-title">Field Checklist</h4>
    <hr >
    <b-row v-if="!isFetching" class="mb-3">
      <b-col sm="12" md="6">
        <div class="font-weight-bold">
          <span class="mr-1">Vehicle:</span>
          <span>{{ `${vehicle.vehicleNumber} ${vehicle.make} ${vehicle.model}` }}</span>
        </div>
      </b-col>
      <b-col sm="12" md="6">
        <div class="d-flex" :class="[$mq !== 'sm' ? 'justify-content-end mt-0' : 'mt-3']">
          <label>Mileage</label>&nbsp;
          <b-form-input v-model="checklistForm.odometer" size="sm" style="padding-right: 0; width: 50%" />
        </div>
      </b-col>
    </b-row>
    <ChecklistForm v-if="!isFetching" v-model="checklistForm" />
    <div class="border p-3">
      <DamageForm v-if="!isFetching" v-model="damageForm" />
    </div>
    <div class="d-flex justify-content-between mt-3">
      <b-btn
        :size="$mq === 'sm' ? 'sm' : ''"
        variant="secondary"
        @click="$router.push({ name: 'VehicleMonitoring', query: { licensePlate: $route.params.licensePlate } })">
        Close without saving
      </b-btn>
      <b-btn
        :size="$mq === 'sm' ? 'sm' : ''"
        variant="success"
        :disabled="isPosting"
        @click="handleSubmit">
        Save
      </b-btn>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { toastr } from '@/services'
import ChecklistForm from './ChecklistForm'
import DamageForm from './DamageForm'

export default {
  name: 'FieldChecklist',
  components: {
    ChecklistForm,
    DamageForm
  },
  data () {
    return {
      isPosting: false,
      isFetching: false,
      checklistForm: {
        interiorCheck: 0,
        engineBay: 0,
        lightingElectronic: 0,
        otherCheck: 0,
        interiorRemarks: '',
        engineBayRemarks: '',
        lightingElectronicRemarks: '',
        odometer: undefined
      },
      damageForm: {
        image: undefined,
        totalIndicatedDamages: undefined
      }
    }
  },
  computed: {
    ...mapState('vmts', ['vehicles', 'damageData']),
    vehicle() {
      return this.vehicles.length ? this.vehicles[0] : {}
    }
  },
  created () {
    this.isFetching = true
    Promise.all([
      this.fetchData(),
      this.fetchDamage()
    ]).then(() => {
      this.isFetching = false
    })
  },
  methods: {
    async fetchData () {
      await this.$store.dispatch('vmts/getVehicleList', { licensePlate: this.$route.params.licensePlate })
      return
    },
    async fetchDamage () {
      await this.$store.dispatch('vmts/getDamage', { licensePlate: this.$route.params.licensePlate }
      )
      const tmp = JSON.parse(JSON.stringify(this.damageData))
      this.damageForm.totalIndicatedDamages = tmp.totalIndicatedDamages
      this.damageForm.image = tmp.fileUrl
      return
    },
    async handleSubmit() {
      try {
        this.isPosting = true
        await this.$store.dispatch('vmts/saveChecklist', [{ ...this.checklistForm, licensePlate: this.vehicle.vehicleNumber }])
        const damagePayload = new FormData()
        damagePayload.append('image', this.damageForm.image)
        damagePayload.append('totalIndicatedDamages', this.damageForm.totalIndicatedDamages)
        damagePayload.append('licensePlate', this.vehicle.vehicleNumber)
        await this.$store.dispatch('vmts/uploadDamage', damagePayload)
        this.isPosting = false
        toastr.success(false, 200)
        this.$router.push({ name: 'VehicleMonitoring', query: { licensePlate: this.$route.params.licensePlate } })
      } catch (err) {
        console.log(err)
      }
    }
  }
}
</script>

<style>

</style>